export enum ExamTaskGroupSolutionAssigmentState {
  AssignedToCurrentUser,
  AssignedToOtherExaminer,
  Unassigned,
}

export const ExamTaskGroupSolutionAssigmentStateText = ['Ja', 'CZWO', 'Nieprzypisane'];
